// 此文件由 json_to_games.py 自动生成
// 生成时间: 2025-03-25 21:46:06

export default {
  "id": "robby-the-lava-tsunami",
  "slug": "robby-the-lava-tsunami",
  "publisher": "GoGameVault",
  "thumbnail": "https://img.gamedistribution.com/163c6611639748e6a0f43ebdf72e4e6b-512x384.jpg",
  "gameUrl": "https://html5.gamedistribution.com/163c6611639748e6a0f43ebdf72e4e6b/",
  "releaseDate": "2025-03-25",
  "rating": 4.5,
  "plays": 0,
  "isNew": true,
  "isPopular": false,
  "isRecommended": false,
  "i18n": {
    "en": {
      "title": "Robby The Lava Tsunami",
      "description": "In this game, you have to get to the finish line and not get caught in the lava tsunami. The game is similar to the popular mode from roblox, but there are unique abilities waiting for you. Use them to be better than your opponents.\nThis is a game for fans of jumping, speed, parkour.\nThe game has many skins for your character, and you can also buy a fashionable hat.",
      "instructions": "Control (computer):\n● WASD - Movement\n● Mouse - Camera Overview\n● Space - Jump\n● Tab or Escape Pause\n● Keys 1, 2, 3, 4, 5 - Activating abilities\n\nControl (phone):\n● Using the game interface\n● Move in any place - Camera view",
      "genres": [
        "Casual"
      ],
      "tags": [
        "customize",
        "platformer",
        "runner",
        "skill"
      ]
    },
    "zh-CN": {
      "title": "罗比火山海啸",
      "description": "在这个游戏中，你需要到达终点线，不要被熔岩海啸捕获。游戏类似于roblox流行的模式，但你将拥有独特的技能等待你去发现。利用它们来超越你的对手。\n这是一款适合喜欢跳跃、速度和跑酷的玩家游戏。\n游戏为你的角色提供了许多皮肤，你还可以购买一顶时尚的帽子。",
      "instructions": "电脑控制：\n● WASD - 移动\n● 鼠标 - 摄像机概览\n● 空格 - 跳跃\n● Tab或Esc 暂停\n● 键盘1、2、3、4、5 - 激活能力\n\n手机控制：\n● 使用游戏界面\n● 在任何地方移动 - 摄像机视角",
      "genres": [
        "休闲"
      ],
      "tags": [
        "自定义",
        "平台游戏",
        "跑酷",
        "技能"
      ]
    },
    "zh-TW": {
      "title": "羅比火山海嘯",
      "description": "在這款遊戲中，你必須達到終點線，並且別讓岩漿海嘯捕捉到你。這款遊戲類似於來自Roblox的流行模式，但等待著你的有獨特的能力。利用它們來超越你的對手。\n這是一款適合喜歡跳躍、速度、障礙跑的玩家。\n遊戲中有許多角色皮肤供你選擇，你還可以購買一頂時尚的帽子。",
      "instructions": "控制（電腦）：\n● WASD - 移動\n● 鼠標 - 相機總覽\n● 空格鍵 - 跳躍\n● Tab 或 Escape 鍵 - 暫停\n● 鍵盤 1、2、3、4、5 鍵 - 激活能力\n\n控制（手機）：\n● 使用遊戲介面\n● 在任何地方移動 - 相機視角",
      "genres": [
        "隨便的"
      ],
      "tags": [
        "自訂化",
        "平台遊戲",
        "跑酷遊戲",
        "技巧"
      ]
    },
    "zh-HK": {
      "title": "羅比火山海嘯",
      "description": "在這個遊戲中，你要達到終點線並不要被熔岩海嘯捕獲。這個遊戲類似於來自Roblox的流行模式，但等待著你的是獨特的能力。利用它們來超越你的對手。\n這是一款適合喜歡跳躍、速度、跑酷的粉絲的遊戲。\n遊戲有許多為你角色設計的皮膚，你也可以購買一頂時尚的帽子。",
      "instructions": "控制（電腦）:\n● WASD - 移動\n● 鼠標 - 相機概覽\n● 空格 - 跳躍\n● Tab 或 ESC 暫停\n● 鍵盤 1, 2, 3, 4, 5 - 激活能力\n\n控制（手機）:\n● 使用遊戲介面\n● 在任何地方移動 - 相機視角",
      "genres": [
        "隨機"
      ],
      "tags": [
        "自訂",
        "平台遊戲",
        "跑酷遊戲",
        "技能"
      ]
    },
    "ja": {
      "title": "ロビー・ラバ・ツunami",
      "description": "このゲームでは、ゴールまで行き、溶岩の津波に捕まらないようにしなければなりません。このゲームはrobloxの人気モードに似ていますが、あなたに待っているユニークな能力があります。それらを使って、ライバルを圧倒しましょう。\nこれはジャンプ、スピード、パークアウトのファンのためのゲームです。\nゲームには多くのキャラクタースキンがあり、ファッション的な帽子も購入できます。",
      "instructions": "コントロール（コンピュータ）:\n● WASD - 移動\n● マウス - カメラオーバービュー\n● スペース - 跳躍\n● タブまたはエスケープで一時停止\n● キー1、2、3、4、5 - 能力の発動\n\nコントロール（携帯電話）:\n● ゲームインターフェースの使用\n● どこでも移動 - カメラビュー",
      "genres": [
        "カジュアル"
      ],
      "tags": [
        "カスタマイズ",
        "プラットフォームゲーム",
        "ランナー",
        "スキル"
      ]
    },
    "ko": {
      "title": "로비 레이크 쓰나미",
      "description": "이 게임에서는 종료선에 도달해 레이븐 터널에 걸리지 않도록 해야 합니다. 이 게임은 로빅스에서 인기가 있는 모드와 비슷하지만, 독특한 능력이 기다리고 있습니다. 이를 사용하여 상대보다 나은 성과를 거두세요.\n이 게임은 점프, 속도, 파르кур을 사랑하는 팬들을 위한 게임입니다.\n게임에는 여러 가지 캐릭터 스킨이 있으며, 패션스러운 쓰리켓도 구매할 수 있습니다.",
      "instructions": "컨트롤 (컴퓨터):\n● WASD - 이동\n● 마우스 - 카메라 전체 시점\n● 공백 - 점프\n● 탭 또는 ESC 키 - 일시 중지\n● 키 1, 2, 3, 4, 5 - 능력 활성화\n\n컨트롤 (폰):\n● 게임 인터페이스 사용\n● 어디서든 이동 - 카메라 시점",
      "genres": [
        "캐주얼"
      ],
      "tags": [
        "カスタマイズ",
        "플랫폼어",
        "러너",
        "스킬"
      ]
    },
    "fr": {
      "title": "Robby Le Tsunami de Lave",
      "description": "Dans ce jeu, vous devez atteindre la ligne d'arrivée sans vous faire attraper par la vague de lave. Le jeu est similaire au mode populaire de Roblox, mais il comporte des capacités uniques qui vous attendent. Utilisez-les pour être meilleur que vos adversaires.\nC'est un jeu pour les fans de saut, de vitesse et de parkour.\nLe jeu propose de nombreux skins pour votre personnage, et vous pouvez également acheter un chapeau à la mode.",
      "instructions": "Contrôle (ordinateur) :\n● WASD - Déplacement\n● Souris - Vue d'ensemble de la caméra\n● Espace - Saut\n● Tab ou Échap pour mettre en pause\n●Touches 1, 2, 3, 4, 5 - Activation des capacités\n\nContrôle (phone) :\n● Utilisation de l'interface de jeu\n● Déplacement dans tous les endroits - Vue de la caméra",
      "genres": [
        "Occasionnel"
      ],
      "tags": [
        "personnaliser",
        "plate-forme,runner",
        "compétence"
      ]
    }
  }
};
